import { Home, Building2, BedSingle, Store, Trees, Sparkles } from "lucide-react";

const ICONS = { buy: Home, rent: Building2, pg: BedSingle, commercial: Store, plot: Trees };

export const CategoryChips = ({ categories, active, onSelect }) => (
  <div className="flex items-center gap-8 overflow-x-auto no-scrollbar py-4" data-testid="category-chip-row">
    <button
      onClick={() => onSelect(null)}
      className={`flex shrink-0 flex-col items-center gap-2 pb-3 border-b-2 transition-colors duration-200 ${
        !active ? "border-foreground text-foreground" : "border-transparent text-muted-foreground hover:text-foreground"
      }`}
      data-testid="category-chip-all"
    >
      <Sparkles className="h-6 w-6" strokeWidth={1.6} />
      <span className="text-xs font-semibold whitespace-nowrap">All</span>
    </button>
    {categories.map((c) => {
      const Icon = ICONS[c.slug] || Home;
      const on = active === c.slug;
      return (
        <button
          key={c.slug}
          onClick={() => onSelect(c.slug)}
          className={`flex shrink-0 flex-col items-center gap-2 pb-3 border-b-2 transition-colors duration-200 ${
            on ? "border-foreground text-foreground" : "border-transparent text-muted-foreground hover:text-foreground"
          }`}
          data-testid={`category-tile-${c.slug}`}
        >
          <Icon className="h-6 w-6" strokeWidth={1.6} />
          <span className="text-xs font-semibold whitespace-nowrap">{c.name}</span>
        </button>
      );
    })}
  </div>
);

export default CategoryChips;
